import { useEffect } from 'react';

const shouldOpen = (href: string, target: EventTarget | null) =>
  target instanceof HTMLAnchorElement && target.hash === href;

export interface UseOnHrefClickProps {
  href: string;
  onClick: () => void;
}

export const useOnHrefClick = ({ href, onClick }: UseOnHrefClickProps) =>
  useEffect(() => {
    const onOpen = (event: MouseEvent) => {
      if (shouldOpen(href, event.target)) {
        event.preventDefault();
        onClick();
      }
    };
    document.addEventListener('click', onOpen);

    return () => document.removeEventListener('click', onOpen);
  }, [href, onClick]);
